document.addEventListener('DOMContentLoaded', initProductPage);

function initProductPage() {
  const page = document.querySelector('[data-product-page]');
  if (!page || page.dataset.productPageInit) return;
  page.dataset.productPageInit = 'true';

  const config = window.ProductPageConfig || {};
  const variants = parseJson(page.querySelector('[data-product-variants]'));
  const form = page.querySelector('[data-product-form]');
  const variantInput = form?.querySelector('[name="id"], [data-variant-id-input]');
  const priceEl = page.querySelector('[data-product-price]');
  const optionPickers = page.querySelectorAll('[data-option-picker]');
  const variantPickersWrap = page.querySelector('[data-variant-pickers]');
  const addBtn = page.querySelector('[data-add-to-cart]');
  const addBtnText = page.querySelector('[data-add-to-cart-text]');
  const netQtyEl = page.querySelector('[data-net-quantity]');

  const optionCount = optionPickers.length;
  let selectedOptions = [];
  let selectedIndex = variants.findIndex((v) => v.selected);
  if (selectedIndex < 0) selectedIndex = 0;

  function variantIdString(variant) {
    return variant?.id != null ? String(variant.id) : '';
  }

  function getVariantOptions(variant) {
    if (!variant) return [];
    return [variant.option1, variant.option2, variant.option3].slice(0, optionCount);
  }

  function findVariantByOptions(options) {
    return variants.find((variant) => {
      const variantOptions = getVariantOptions(variant);
      return variantOptions.every((value, index) => value === options[index]);
    });
  }

  function initSelectedOptions() {
    const current =
      variants.find((v) => v.selected) ||
      variants.find((v) => v.available) ||
      variants[0];
    if (!current) return;
    selectedOptions = getVariantOptions(current);
    selectedIndex = variants.indexOf(current);
  }

  function syncSelectedVariantFromInput() {
    const inputId = variantInput?.value ? String(variantInput.value) : '';
    const idx = variants.findIndex((v) => variantIdString(v) === inputId);
    if (idx >= 0) {
      selectedIndex = idx;
      selectedOptions = getVariantOptions(variants[idx]);
      return variants[idx];
    }
    return getSelectedVariant();
  }

  function ensureValidVariantInput() {
    const validIds = variants.map(variantIdString).filter(Boolean);
    const inputId = variantInput?.value ? String(variantInput.value) : '';
    const fallbackVariant = variants.find((v) => v.available) || variants[0];

    if (!fallbackVariant) return null;

    if (!inputId || !validIds.includes(inputId)) {
      selectedIndex = variants.indexOf(fallbackVariant);
      selectedOptions = getVariantOptions(fallbackVariant);
      if (variantInput) variantInput.value = variantIdString(fallbackVariant);
      updateVariantUI();
      return getSelectedVariant();
    }

    const current = syncSelectedVariantFromInput();
    if (current && !current.available && fallbackVariant.available) {
      selectedIndex = variants.indexOf(fallbackVariant);
      selectedOptions = getVariantOptions(fallbackVariant);
      if (variantInput) variantInput.value = variantIdString(fallbackVariant);
      updateVariantUI();
    }

    return getSelectedVariant();
  }

  function resolveVariantForOption(optionIndex, value) {
    const preferred = [...selectedOptions];
    preferred[optionIndex] = value;

    let variant = findVariantByOptions(preferred);
    if (variant) return variant;

    return (
      variants.find((v) => getVariantOptions(v)[optionIndex] === value && v.available) ||
      variants.find((v) => getVariantOptions(v)[optionIndex] === value) ||
      null
    );
  }

  function isOptionValueAvailable(optionIndex, value) {
    const testOptions = [...selectedOptions];
    testOptions[optionIndex] = value;
    const variant = findVariantByOptions(testOptions);
    return Boolean(variant?.available);
  }

  function optionValueExists(optionIndex, value) {
    const testOptions = [...selectedOptions];
    testOptions[optionIndex] = value;
    return Boolean(findVariantByOptions(testOptions));
  }

  function selectOption(optionIndex, value) {
    const variant = resolveVariantForOption(optionIndex, value);
    if (!variant) return;

    selectedOptions = getVariantOptions(variant);
    selectedIndex = variants.indexOf(variant);
    updateVariantUI();
  }

  function parseJson(el) {
    if (!el) return [];
    try {
      return JSON.parse(el.textContent);
    } catch {
      return [];
    }
  }

  function formatMoney(cents) {
    if (window.Shopify && typeof Shopify.formatMoney === 'function') {
      return Shopify.formatMoney(cents, config.moneyFormat);
    }
    return `$${(cents / 100).toFixed(2)}`;
  }

  function getSelectedVariant() {
    return variants[selectedIndex] || variants[0];
  }

  function updateProductImage(variant) {
    const img = page.querySelector('.product-page__image[data-image-lightbox-trigger]');
    if (!img) return;

    const image = variant?.image || config.defaultImage;
    if (!image) return;

    img.src = image.src || image.src900;
    img.alt = image.alt || '';

    if (image.src400 && image.src600 && image.src900) {
      img.srcset = `${image.src400} 400w, ${image.src600} 600w, ${image.src900} 900w`;
    } else {
      img.removeAttribute('srcset');
    }

    if (image.lightboxSrc) img.dataset.lightboxSrc = image.lightboxSrc;
    if (image.alt) img.dataset.lightboxAlt = image.alt;
    if (image.lightboxIndex != null) img.dataset.imageIndex = String(image.lightboxIndex);
  }

  function updateVariantUI() {
    const variant = getSelectedVariant();
    if (!variant) return;

    if (variantInput) variantInput.value = variantIdString(variant);
    if (priceEl) priceEl.textContent = variant.priceFormatted || formatMoney(variant.price);
    if (netQtyEl) netQtyEl.textContent = variant.option1 || variant.title;

    const available = variant.available && !config.comingSoon;
    if (addBtn) addBtn.disabled = !available;
    if (addBtnText) addBtnText.textContent = available ? config.addToCartLabel : config.soldOutLabel;

    const stockRow = page.querySelector('.product-page__price-row');
    let stockBadgeEl = page.querySelector('[data-stock-badge]');
    let stockOutEl = page.querySelector('[data-stock-out]');

    if (available) {
      if (!stockBadgeEl && stockRow) {
        stockBadgeEl = document.createElement('span');
        stockBadgeEl.className = 'product-page__stock';
        stockBadgeEl.dataset.stockBadge = '';
        stockBadgeEl.innerHTML =
          '<span aria-hidden="true"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="10"/><path d="m9 12 2 2 4-4"/></svg></span> In Stock';
        stockRow.appendChild(stockBadgeEl);
      }
      if (stockOutEl) stockOutEl.remove();
      if (stockBadgeEl) {
        stockBadgeEl.hidden = false;
        const qty = variant.inventory_quantity;
        const qtyLabel =
          variant.inventory_management && typeof qty === 'number' && qty > 0
            ? ` (${qty} available)`
            : '';
        stockBadgeEl.innerHTML = `<span aria-hidden="true"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="10"/><path d="m9 12 2 2 4-4"/></svg></span>In Stock${qtyLabel}`;
      }
    } else {
      if (!stockOutEl && stockRow) {
        stockOutEl = document.createElement('span');
        stockOutEl.className = 'product-page__stock product-page__stock--out';
        stockOutEl.dataset.stockOut = '';
        stockOutEl.textContent = 'Out of Stock';
        stockRow.appendChild(stockOutEl);
      }
      if (stockBadgeEl) stockBadgeEl.remove();
      if (stockOutEl) stockOutEl.hidden = false;
    }

    optionPickers.forEach((picker) => {
      const optionIndex = Number(picker.dataset.optionIndex);
      const valueButtons = picker.querySelectorAll('[data-option-value]');

      valueButtons.forEach((btn) => {
        const value = btn.dataset.optionValue;
        const isSelected = selectedOptions[optionIndex] === value;
        const exists = optionValueExists(optionIndex, value);
        const availableOption = isOptionValueAvailable(optionIndex, value);

        btn.classList.toggle('is-selected', isSelected);
        btn.setAttribute('aria-checked', isSelected ? 'true' : 'false');
        btn.disabled = !exists || !availableOption;

        let badge = btn.querySelector('.product-page__variant-chip-badge');
        if (exists && !availableOption) {
          if (!badge) {
            badge = document.createElement('span');
            badge.className = 'product-page__variant-chip-badge';
            badge.textContent = 'Out of Stock';
            btn.appendChild(badge);
          }
        } else if (badge) {
          badge.remove();
        }
      });
    });

    updateProductImage(variant);
  }

  if (variants.length <= 1 && variantPickersWrap) {
    variantPickersWrap.hidden = true;
  }

  initSelectedOptions();

  optionPickers.forEach((picker) => {
    const optionIndex = Number(picker.dataset.optionIndex);
    picker.querySelectorAll('[data-option-value]').forEach((btn) => {
      btn.addEventListener('click', () => {
        if (btn.disabled) return;
        selectOption(optionIndex, btn.dataset.optionValue);
      });
    });
  });

  ensureValidVariantInput();
  updateVariantUI();

  const initialVariant = getSelectedVariant();
  if (initialVariant && window.MetaPixelEvents) {
    window.MetaPixelEvents.trackViewContent({
      variantId: initialVariant.id,
      name: config.productTitle,
      value: initialVariant.price,
      currency: config.currency
    });
  }

  let isAdding = false;

  async function handleAddToCart() {
    if (!form || isAdding) return;

    const variant = syncSelectedVariantFromInput() || ensureValidVariantInput();
    const variantId = variantInput?.value ? String(variantInput.value) : variantIdString(variant);

    if (!variantId || !variant || config.comingSoon) return;

    if (!variant.available) {
      if (addBtnText) addBtnText.textContent = config.soldOutLabel || 'Out of Stock';
      return;
    }

    if (variantIdString(variant) !== variantId) {
      if (addBtnText) addBtnText.textContent = 'Variant mismatch — please refresh the page';
      return;
    }

    isAdding = true;
    if (addBtn) addBtn.disabled = true;

    try {
      if (window.CartDrawer?.addFromForm) {
        await window.CartDrawer.addFromForm(form);
        await window.CartDrawer.show();
      } else if (window.CartDrawer?.addItem) {
        await window.CartDrawer.addItem(variantId, 1);
        await window.CartDrawer.show();
      } else {
        const formData = new FormData(form);
        if (!formData.get('quantity')) formData.set('quantity', '1');
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { Accept: 'application/json' },
          credentials: 'same-origin',
          body: formData
        });
        const data = await res.json().catch(() => ({}));
        if (!res.ok) throw new Error(data.description || data.message || 'Add to cart failed');
        const cart = await fetch('/cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' }).then((r) => r.json());
        if (window.MetaPixelEvents) {
          const addedItem = (cart.items || []).find((item) => String(item.variant_id) === variantId);
          window.MetaPixelEvents.trackAddToCart(
            addedItem || {
              variant_id: variantId,
              id: variantId,
              quantity: 1,
              price: variant.price,
              product_title: config.productTitle,
              currency: config.currency
            }
          );
        }
        await updateCartCount();
      }
      if (addBtnText) addBtnText.textContent = config.addedLabel || 'Added';
      setTimeout(() => {
        if (addBtnText) addBtnText.textContent = config.addToCartLabel;
      }, 1500);
    } catch (error) {
      if (addBtnText) {
        addBtnText.textContent = error?.message || config.errorLabel || 'Error — try again';
      }
      setTimeout(() => {
        if (addBtnText) addBtnText.textContent = config.addToCartLabel;
      }, 2500);
    } finally {
      isAdding = false;
      if (addBtn) addBtn.disabled = !(getSelectedVariant()?.available && !config.comingSoon);
    }
  }

  if (addBtn) {
    addBtn.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();
      handleAddToCart();
    });
  }

  if (form) {
    form.addEventListener(
      'submit',
      (event) => {
        event.preventDefault();
        event.stopImmediatePropagation();
      },
      true
    );
  }

  initProductTabs(page);
  initProductGallery(page);
}

function initProductGallery(page) {
  const thumbs = page.querySelectorAll('[data-product-thumb]');
  const slides = page.querySelectorAll('[data-product-media-slide]');
  if (!thumbs.length || !slides.length) return;

  thumbs.forEach((thumb) => {
    thumb.addEventListener('click', () => {
      const mediaId = thumb.dataset.mediaId;
      thumbs.forEach((t) => {
        const active = t === thumb;
        t.classList.toggle('is-active', active);
        t.setAttribute('aria-selected', String(active));
      });
      slides.forEach((slide) => {
        const active = slide.dataset.mediaId === mediaId;
        slide.classList.toggle('is-active', active);
        slide.hidden = !active;
        if (active && slide.dataset.mediaType === 'video') {
          slide.querySelector('video')?.pause();
        }
      });
    });
  });
}

async function updateCartCount() {
  try {
    const cart = await fetch('/cart.js').then((r) => r.json());
    const bubble = document.querySelector('.site-header__cart-count');
    if (!bubble) {
      const btn = document.getElementById('cart-icon-bubble');
      if (btn && cart.item_count > 0) {
        const span = document.createElement('span');
        span.className = 'site-header__cart-count';
        span.textContent = cart.item_count;
        btn.appendChild(span);
      }
      return;
    }
    if (cart.item_count > 0) {
      bubble.textContent = cart.item_count;
      bubble.hidden = false;
    } else {
      bubble.remove();
    }
  } catch {
    /* ignore */
  }
}

function initProductTabs(page) {
  const tabs = page.querySelectorAll('[data-product-tab]');
  const panels = page.querySelectorAll('[data-product-panel]');
  if (!tabs.length) return;

  tabs.forEach((tab) => {
    tab.addEventListener('click', () => {
      const key = tab.dataset.productTab;
      tabs.forEach((t) => {
        const active = t.dataset.productTab === key;
        t.classList.toggle('is-active', active);
        t.setAttribute('aria-selected', String(active));
      });
      panels.forEach((panel) => {
        panel.hidden = panel.dataset.productPanel !== key;
      });
    });
  });
}
